import React from 'react';

/**
 * Placeholder component that displays a loading skeleton for the Property and Portfolio show page
 * @returns {React.ReactElement} - Placholder component
 */
function Placeholder() {
  return (
    <>
      {/* Chart Placeholder */}
      <div className="mt-4 mb-4 card" aria-hidden="true">
        <div className="card-body">
          {/* Chart Controls and Summaries */}
          <div className="d-flex justify-content-between mb-4">
            {/* Left Summary */}
            <div className="flex-fill order-1 order-xs-1 col-xs-12 me-2">
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-8" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-9" />
              </div>
              <div>
                <span className="placeholder placeholder-glow bg-darken col-7" />
              </div>
            </div>

            {/* Center Controls */}
            <div className="flex-fill justify-content-center order-2 order-xs-3 col-xs-12 mx-2">
              <div className="d-flex justify-content-center gap-2">
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '60px', height: '36px' }} />
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '60px', height: '36px' }} />
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '60px', height: '36px' }} />
              </div>
            </div>

            {/* Right Summary */}
            <div className="flex-fill order-3 order-xs-2 col-xs-12 ms-2">
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-8" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-9" />
              </div>
              <div>
                <span className="placeholder placeholder-glow bg-darken col-7" />
              </div>
            </div>
          </div>

          {/* Chart Area */}
          <div style={{
            height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
          >
            <span className="placeholder placeholder-glow bg-darken col-12" style={{ height: '100%' }} />
          </div>
        </div>
      </div>

      {/* Trade Summary Cards Placeholder */}
      <div className="trade-summaries mb-4 row row-cols-1 row-cols-sm-2" aria-hidden="true">
        {/* Import Card */}
        <div className="col mb-4 mb-sm-0">
          <div className="card h-100 trade-summary-imports">
            <div className="card-body">
              <div className="mb-3">
                <span className="placeholder placeholder-glow bg-darken col-6" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-12" style={{ height: '20px' }} />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-9" />
              </div>
              <div>
                <span className="placeholder placeholder-glow bg-darken col-8" />
              </div>
            </div>
            <div className="card-footer">
              <span className="placeholder placeholder-glow bg-darken col-12" />
            </div>
          </div>
        </div>

        {/* Export Card */}
        <div className="col mb-4 mb-sm-0">
          <div className="card h-100 trade-summary-exports">
            <div className="card-body">
              <div className="mb-3">
                <span className="placeholder placeholder-glow bg-darken col-6" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-12" style={{ height: '20px' }} />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>
              <div className="mb-2">
                <span className="placeholder placeholder-glow bg-darken col-9" />
              </div>
              <div>
                <span className="placeholder placeholder-glow bg-darken col-8" />
              </div>
            </div>
            <div className="card-footer">
              <span className="placeholder placeholder-glow bg-darken col-12" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Placeholder;
